import { render, staticRenderFns } from "./MechReview.vue?vue&type=template&id=5cd44862&"
import script from "./MechReview.vue?vue&type=script&lang=js&"
export * from "./MechReview.vue?vue&type=script&lang=js&"
import style0 from "./MechReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports